// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase"; // Import Firestore and Auth configuration
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({}); // Track quiz status for each training
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {

//     document.title = "Trainings - Bee's Care Online Training Program"; 

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setTrainings(trainingsData);

//         // Check quiz status for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             trainingsData.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               statusData[training.id] = docSnap.exists(); // true if quiz exists (taken), false otherwise
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = (trainingId) => {
//     if (quizStatus[trainingId]) {
//       // Navigate to View Result page if quiz has been taken
//       navigate(`/view-training-questions/${trainingId}`);
//     } else {
//       // Navigate to Start Quiz page if quiz has not been taken
//       navigate(`/view-training-questions/${trainingId}`);
//     }
//   };

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>
//       {loading && <p>Loading...</p>}
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {trainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>
//                 <button
//                   onClick={() => handleStartOrViewQuiz(training.id)}
//                   className="btn btn-sm"
//                   style={{
//                     backgroundColor: quizStatus[training.id] ? "#28a745" : "#007bff",
//                     color: "white",
//                   }}
//                 >
//                   {quizStatus[training.id] ? "View Result" : "Start Quiz"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;




// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({}); // Store quiz status, scores, and pass/fail
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setTrainings(trainingsData);

//         // Check quiz status, scores, and pass/fail for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             trainingsData.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail", // Pass if score >= 10
//                 };
//               } else {
//                 statusData[training.id] = { taken: false, score: null, status: "Not Attempted" };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>
//       {loading && <p>Loading...</p>}
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Score</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {trainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>
//                 {quizStatus[training.id]?.taken
//                   ? `${quizStatus[training.id].score} / 20`
//                   : "Not Taken"}
//               </td>
//               <td
//                 style={{
//                   color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {quizStatus[training.id]?.status}
//               </td>
//               <td>
//                 <button
//                   onClick={() => handleStartOrViewQuiz(training.id)}
//                   className="btn btn-sm"
//                   style={{
//                     backgroundColor: quizStatus[training.id]?.taken
//                       ? "#28a745"
//                       : "#007bff",
//                     color: "white",
//                   }}
//                 >
//                   {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;





// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({}); // Store quiz status, scores, and pass/fail
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setTrainings(trainingsData);

//         // Check quiz status, scores, and pass/fail for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             trainingsData.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail", // Pass if score >= 10
//                 };
//               } else {
//                 statusData[training.id] = { taken: false, score: null, status: "Not Attempted" };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>
//       {loading && <p>Loading...</p>}
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Training Type</th>
//             <th>Score</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {trainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>
//                 {training.type
//                   ? training.type
//                       .toLowerCase()
//                       .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
//                   : "N/A"}
//               </td>
//               <td>
//                 {quizStatus[training.id]?.taken
//                   ? `${quizStatus[training.id].score} / 20`
//                   : "Not Taken"}
//               </td>
//               <td
//                 style={{
//                   color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {quizStatus[training.id]?.status}
//               </td>
//               <td>
//                 <button
//                   onClick={() => handleStartOrViewQuiz(training.id)}
//                   className="btn btn-sm"
//                   style={{
//                     backgroundColor: quizStatus[training.id]?.taken
//                       ? "#28a745"
//                       : "#007bff",
//                     color: "white",
//                   }}
//                 >
//                   {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;
















// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) => a.name.localeCompare(b.name));
//         setTrainings(sortedTrainings);

//         // Check quiz status, scores, and pass/fail for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             sortedTrainings.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail",
//                 };
//               } else {
//                 statusData[training.id] = {
//                   taken: false,
//                   score: null,
//                   status: "Not Attempted",
//                 };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   // Filter the trainings based on the search query
//   const filteredTrainings = trainings.filter((training) =>
//     training.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Separate trainings into two categories
//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading && <p>Loading...</p>}

//       {/* Question Paper Trainings */}
//       <h3>Question Paper Trainings</h3>
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Training Type</th>
//             <th>Score</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {questionPaperTrainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>{training.type}</td>
//               <td>
//                 {quizStatus[training.id]?.taken
//                   ? `${quizStatus[training.id].score} / 20`
//                   : "Not Taken"}
//               </td>
//               <td
//                 style={{
//                   color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {quizStatus[training.id]?.status}
//               </td>
//               <td>
//                 <button
//                   onClick={() => handleStartOrViewQuiz(training.id)}
//                   className="btn btn-sm"
//                   style={{
//                     backgroundColor: quizStatus[training.id]?.taken
//                       ? "#28a745"
//                       : "#007bff",
//                     color: "white",
//                   }}
//                 >
//                   {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Declaration Trainings */}
//       <h3>Declaration Trainings</h3>
//       <table className="table table-striped">
//         <thead>
//           <tr>
//             <th>Training Name</th>
//             <th>Training Type</th>
//             <th>Score</th>
//             <th>Status</th>
//             <th>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {declarationTrainings.map((training) => (
//             <tr key={training.id}>
//               <td>{training.name}</td>
//               <td>{training.type}</td>
//               <td>
//                 {quizStatus[training.id]?.taken
//                   ? `${quizStatus[training.id].score} / 20`
//                   : "Not Required"}
//               </td>
//               <td
//                 style={{
//                   color: quizStatus[training.id]?.taken ? "green" : "red",
//                   fontWeight: "bold",
//                 }}
//               >
//                 {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//               </td>
//               <td>
//                 <button
//                   onClick={() => handleStartOrViewQuiz(training.id)}
//                   className="btn btn-sm"
//                   style={{
//                     backgroundColor: quizStatus[training.id]?.taken
//                       ? "#28a745"
//                       : "#007bff",
//                     color: "white",
//                   }}
//                 >
//                   {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;

















// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Spinner from "react-bootstrap/Spinner"; // Import spinner from react-bootstrap

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) => a.name.localeCompare(b.name));
//         setTrainings(sortedTrainings);

//         // Check quiz status, scores, and pass/fail for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             sortedTrainings.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail",
//                 };
//               } else {
//                 statusData[training.id] = {
//                   taken: false,
//                   score: null,
//                   status: "Not Attempted",
//                 };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   // Filter the trainings based on the search query
//   const filteredTrainings = trainings.filter((training) =>
//     training.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   // Separate trainings into two categories
//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="d-flex justify-content-center">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : filteredTrainings.length === 0 ? (
//         <div><h3>Question Paper Trainings</h3>
//           <p>No trainings found matching your search criteria.</p></div>
//       ) : null}

//       {/* Question Paper Trainings */}
//       {questionPaperTrainings.length > 0 && (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questionPaperTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                         .toLowerCase()
//                         .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
//                       : "N/A"}
//                   </td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Taken"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.status}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Declaration Trainings */}
//       {declarationTrainings.length > 0 && (
//         <div>
//           <h3>Declaration Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {declarationTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                         .toLowerCase()
//                         .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
//                       : "N/A"}
//                   </td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Required"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.taken ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* No trainings found message */}
//       {filteredTrainings.length === 0 && !loading && (
//         <div><h3>Declaration Trainings</h3>
//           <p>No trainings found matching your search criteria.</p></div>
//       )}

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;



























// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc, updateDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Spinner from "react-bootstrap/Spinner";

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) => a.name.localeCompare(b.name));
//         setTrainings(sortedTrainings);

//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             sortedTrainings.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score, attempts = 1 } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail",
//                   attempts,
//                 };
//               } else {
//                 statusData[training.id] = {
//                   taken: false,
//                   score: null,
//                   status: "Not Attempted",
//                   attempts: 0,
//                 };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = async (trainingId, isRetake = false) => {
//     if (isRetake && currentUser) {
//       const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", trainingId);
//       const docSnap = await getDoc(userQuizDocRef);

//       if (docSnap.exists()) {
//         const previousAttempts = docSnap.data().attempts || 1;
//         await updateDoc(userQuizDocRef, { attempts: previousAttempts + 1 });
//       }
//     }
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   const filteredTrainings = trainings.filter((training) =>
//     training.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="d-flex justify-content-center">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : filteredTrainings.length === 0 ? (
//         <div>
//           <h3>Trainings</h3>
//           <p>No trainings found matching your search criteria.</p>
//         </div>
//       ) : null}

//       {/* Question Paper Trainings */}
//       {questionPaperTrainings.length > 0 && (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Attempts</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questionPaperTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                           .toLowerCase()
//                           .replace(/\b\w/g, (char) => char.toUpperCase())
//                       : "N/A"}
//                   </td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Taken"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.status}
//                   </td>
//                   <td>{quizStatus[training.id]?.attempts || 0}</td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                     {quizStatus[training.id]?.taken && quizStatus[training.id]?.status === "Fail" && (
//                       <button
//                         onClick={() => handleStartOrViewQuiz(training.id, true)}
//                         className="btn btn-sm btn-danger ml-2"
//                       >
//                         Retake Test
//                       </button>
//                     )}
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => alert("Open Feedback Form")}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Declaration Trainings */}
//       {declarationTrainings.length > 0 && (
//         <div>
//           <h3>Declaration Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {declarationTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                           .toLowerCase()
//                           .replace(/\b\w/g, (char) => char.toUpperCase())
//                       : "N/A"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.taken ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Declaration" : "Sign Declaration"}
//                     </button>
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => alert("Open Feedback Form")}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;













// import React, { useEffect, useState } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Spinner from "react-bootstrap/Spinner"; // Import spinner from react-bootstrap

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       setLoading(true);
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) => a.name.localeCompare(b.name));
//         setTrainings(sortedTrainings);

//         // Check quiz status, scores, and pass/fail for each training
//         if (currentUser) {
//           const statusData = {};
//           await Promise.all(
//             sortedTrainings.map(async (training) => {
//               const userQuizDocRef = doc(db, "users", currentUser.uid, "quizzes", training.id);
//               const docSnap = await getDoc(userQuizDocRef);
//               if (docSnap.exists()) {
//                 const { score, attempts = 1 } = docSnap.data();
//                 statusData[training.id] = {
//                   taken: true,
//                   score: score || 0,
//                   status: score >= 15 ? "Pass" : "Fail",
//                   attempts,
//                 };
//               } else {
//                 statusData[training.id] = {
//                   taken: false,
//                   score: null,
//                   status: "Not Attempted",
//                   attempts: 0,
//                 };
//               }
//             })
//           );
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   const handleStartOrViewQuiz = async (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   const handleFeedback = (trainingId) => {
//     navigate(`/feedback/${trainingId}`);
//   };

//   const filteredTrainings = trainings.filter((training) =>
//     training.name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="d-flex justify-content-center">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : filteredTrainings.length === 0 ? (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <p>No trainings found matching your search criteria.</p>
//         </div>
//       ) : null}

//       {/* Question Paper Trainings */}
//       {questionPaperTrainings.length > 0 && (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Attempts</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questionPaperTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                           .toLowerCase()
//                           .replace(/\b\w/g, (char) => char.toUpperCase())
//                       : "N/A"}
//                   </td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Taken"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.status}
//                   </td>
//                   <td>{quizStatus[training.id]?.attempts || 0}</td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                     {quizStatus[training.id]?.status === "Fail" && (
//                       <button
//                         className="btn btn-sm btn-danger ml-2"
//                         onClick={() => handleStartOrViewQuiz(training.id)}
//                       >
//                         Retake Test
//                       </button>
//                     )}
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Declaration Trainings */}
//       {declarationTrainings.length > 0 && (
//         <div>
//           <h3>Declaration Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {declarationTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>
//                     {training.type
//                       ? training.type
//                           .toLowerCase()
//                           .replace(/\b\w/g, (char) => char.toUpperCase())
//                       : "N/A"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.taken ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className="btn btn-sm"
//                       style={{
//                         backgroundColor: quizStatus[training.id]?.taken
//                           ? "#28a745"
//                           : "#007bff",
//                         color: "white",
//                       }}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Declaration" : "Sign Declaration"}
//                     </button>
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;













// import React, { useEffect, useState, useMemo } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Spinner from "react-bootstrap/Spinner"; // Import spinner from react-bootstrap

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) =>
//           a.name.localeCompare(b.name)
//         );
//         setTrainings(sortedTrainings);

//         // Fetch quiz status data for all trainings at once
//         if (currentUser) {
//           const statusData = {};
//           const userQuizDocs = await Promise.all(
//             sortedTrainings.map((training) =>
//               getDoc(doc(db, "users", currentUser.uid, "quizzes", training.id))
//             )
//           );

//           userQuizDocs.forEach((docSnap, index) => {
//             const training = sortedTrainings[index];
//             if (docSnap.exists()) {
//               const { score, attempts = 1 } = docSnap.data();
//               statusData[training.id] = {
//                 taken: true,
//                 score: score || 0,
//                 status: score >= 15 ? "Pass" : "Fail",
//                 attempts,
//               };
//             } else {
//               statusData[training.id] = {
//                 taken: false,
//                 score: null,
//                 status: "Not Attempted",
//                 attempts: 0,
//               };
//             }
//           });
//           setQuizStatus(statusData);
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   // Memoize filtered trainings based on the search query
//   const filteredTrainings = useMemo(
//     () => trainings.filter((training) =>
//       training.name.toLowerCase().includes(searchQuery.toLowerCase())
//     ),
//     [trainings, searchQuery]
//   );

//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   const handleStartOrViewQuiz = async (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   const handleFeedback = (trainingId) => {
//     navigate(`/feedback/${trainingId}`);
//   };

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="d-flex justify-content-center">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : filteredTrainings.length === 0 ? (
//         <p>No trainings found matching your search criteria.</p>
//       ) : null}

//       {/* Question Paper Trainings */}
//       {questionPaperTrainings.length > 0 && (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Attempts</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questionPaperTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>{training.type
//                     ? training.type
//                       .toLowerCase()
//                       .replace(/\b\w/g, (char) => char.toUpperCase())
//                     : "N/A"}</td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Taken"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.status}
//                   </td>
//                   <td>{quizStatus[training.id]?.attempts || 0}</td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                     {quizStatus[training.id]?.status === "Fail" && (
//                       <button
//                         className="btn btn-sm btn-danger ml-2"
//                         onClick={() => handleStartOrViewQuiz(training.id)}
//                       >
//                         Retake Test
//                       </button>
//                     )}
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Declaration Trainings */}
//       {declarationTrainings.length > 0 && (
//         <div>
//           <h3>Declaration Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {declarationTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>{training.type?.toUpperCase()}</td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.taken ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Declaration" : "Sign Declaration"}
//                     </button>
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         Feedback
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;

















// import React, { useEffect, useState, useMemo } from "react";
// import { db, auth } from "../firebase";
// import { collection, getDocs, doc, getDoc, getDocFromServer } from "firebase/firestore";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Spinner from "react-bootstrap/Spinner"; // Import spinner from react-bootstrap

// const ViewTrainings = () => {
//   const [trainings, setTrainings] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [quizStatus, setQuizStatus] = useState({});
//   const [feedbackStatus, setFeedbackStatus] = useState({}); // New state to track feedback
//   const [searchQuery, setSearchQuery] = useState("");
//   const navigate = useNavigate();
//   const currentUser = auth.currentUser;

//   useEffect(() => {
//     document.title = "Trainings - Bee's Care Online Training Program";

//     const fetchTrainings = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, "trainings"));
//         const trainingsData = querySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));

//         // Sort trainings by name
//         const sortedTrainings = trainingsData.sort((a, b) =>
//           a.name.localeCompare(b.name)
//         );
//         setTrainings(sortedTrainings);

//         // Fetch quiz status data for all trainings at once
//         if (currentUser) {
//           const statusData = {};
//           const feedbackData = {}; // Object to track feedback submission status
//           const userQuizDocs = await Promise.all(
//             sortedTrainings.map((training) =>
//               getDoc(doc(db, "users", currentUser.uid, "quizzes", training.id))
//             )
//           );

//           const userFeedbackDocs = await Promise.all(
//             sortedTrainings.map((training) =>
//               getDoc(doc(db, "users", currentUser.uid, "feedback", training.id))
//             )
//           );

//           // Loop through to set the quiz and feedback statuses
//           userQuizDocs.forEach((docSnap, index) => {
//             const training = sortedTrainings[index];
//             if (docSnap.exists()) {
//               const { score, attempts = 1 } = docSnap.data();
//               statusData[training.id] = {
//                 taken: true,
//                 score: score || 0,
//                 status: score >= 15 ? "Pass" : "Fail",
//                 attempts,
//               };
//             } else {
//               statusData[training.id] = {
//                 taken: false,
//                 score: null,
//                 status: "Not Attempted",
//                 attempts: 0,
//               };
//             }
//           });

//           // Check if feedback exists for each training
//           userFeedbackDocs.forEach((docSnap, index) => {
//             const training = sortedTrainings[index];
//             if (docSnap.exists()) {
//               feedbackData[training.id] = true; // Feedback submitted
//             } else {
//               feedbackData[training.id] = false; // Feedback not submitted
//             }
//           });

//           setQuizStatus(statusData);
//           setFeedbackStatus(feedbackData); // Set the feedback status
//         }
//       } catch (error) {
//         toast.error("Error fetching trainings: " + error.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchTrainings();
//   }, [currentUser]);

//   // Memoize filtered trainings based on the search query
//   const filteredTrainings = useMemo(
//     () => trainings.filter((training) =>
//       training.name.toLowerCase().includes(searchQuery.toLowerCase())
//     ),
//     [trainings, searchQuery]
//   );

//   const questionPaperTrainings = filteredTrainings.filter(
//     (training) => training.type === "mcq" || training.type === "true_false"
//   );
//   const declarationTrainings = filteredTrainings.filter(
//     (training) => training.type === "declaration"
//   );

//   const handleStartOrViewQuiz = async (trainingId) => {
//     navigate(`/view-training-questions/${trainingId}`);
//   };

//   const handleFeedback = (trainingId) => {
//     navigate(`/feedback/${trainingId}`);
//   };

//   return (
//     <div className="container mt-3">
//       <h2>All Trainings</h2>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search Trainings"
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {loading ? (
//         <div className="d-flex justify-content-center">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : filteredTrainings.length === 0 ? (
//         <p>No trainings found matching your search criteria.</p>
//       ) : null}

//       {/* Question Paper Trainings */}
//       {questionPaperTrainings.length > 0 && (
//         <div>
//           <h3>Question Paper Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Score</th>
//                 <th>Status</th>
//                 <th>Attempts</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {questionPaperTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>{training.type ? training.type.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "N/A"}</td>
//                   <td>
//                     {quizStatus[training.id]?.taken
//                       ? `${quizStatus[training.id].score} / 20`
//                       : "Not Taken"}
//                   </td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.status === "Pass" ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.status}
//                   </td>
//                   <td>{quizStatus[training.id]?.attempts || 0}</td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
//                     </button>
//                     {quizStatus[training.id]?.status === "Fail" && (
//                       <button
//                         className="btn btn-sm btn-danger ml-2"
//                         onClick={() => handleStartOrViewQuiz(training.id)}
//                       >
//                         Retake Test
//                       </button>
//                     )}
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         {feedbackStatus[training.id] ? "Feedback Submitted" : "Give Feedback"}
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Declaration Trainings */}
//       {declarationTrainings.length > 0 && (
//         <div>
//           <h3>Declaration Trainings</h3>
//           <table className="table table-striped">
//             <thead>
//               <tr>
//                 <th>Training Name</th>
//                 <th>Training Type</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {declarationTrainings.map((training) => (
//                 <tr key={training.id}>
//                   <td>{training.name}</td>
//                   <td>{training.type?.toUpperCase()}</td>
//                   <td
//                     style={{
//                       color: quizStatus[training.id]?.taken ? "green" : "red",
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
//                   </td>
//                   <td>
//                     <button
//                       onClick={() => handleStartOrViewQuiz(training.id)}
//                       className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
//                     >
//                       {quizStatus[training.id]?.taken ? "View Declaration" : "Sign Declaration"}
//                     </button>
//                     {quizStatus[training.id]?.taken && (
//                       <button
//                         className="btn btn-sm btn-warning ml-2"
//                         onClick={() => handleFeedback(training.id)}
//                       >
//                         {feedbackStatus[training.id] ? "Feedback Submitted" : "Give Feedback"}
//                       </button>
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
//     </div>
//   );
// };

// export default ViewTrainings;














import React, { useEffect, useState, useMemo, useCallback } from "react";
import { db, auth } from "../firebase";
import { collection, getDocs, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";

const ViewTrainings = () => {
  const [trainings, setTrainings] = useState([]);
  const [retakes, setRetake] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quizStatus, setQuizStatus] = useState({});
  const [feedbackStatus, setFeedbackStatus] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const currentUser = auth.currentUser;

  useEffect(() => {
    document.title = "Trainings - Bee's Care Online Training Program";

    // const fetchTrainings = async () => {
    //   if (!currentUser) {
    //     toast.error("You must be logged in to view trainings.");
    //     navigate("/login");
    //     return;
    //   }

    //   try {
    //     const querySnapshot = await getDocs(collection(db, "trainings"));
    //     const trainingsData = querySnapshot.docs.map((doc) => ({
    //       id: doc.id,
    //       ...doc.data(),
    //     }));

        

    //     const sortedTrainings = trainingsData.sort((a, b) =>
    //       a.name.localeCompare(b.name)
    //     );
    //     setTrainings(sortedTrainings);

    //     const quizCollection = collection(db, "users", currentUser.uid, "quizzes");
    //     const feedbackCollection = collection(db, "users", currentUser.uid, "feedback");
       

    //     const [quizDocs, feedbackDocs] = await Promise.all([
    //       getDocs(quizCollection),
    //       getDocs(feedbackCollection),
    //     ]);

    //     const statusData = {};
    //     const feedbackData = {};

    //     sortedTrainings.forEach((training) => {
    //       const quizDoc = quizDocs.docs.find((doc) => doc.id === training.id);
    //       const feedbackDoc = feedbackDocs.docs.find((doc) => doc.id === training.id);

    //       statusData[training.id] = quizDoc
    //         ? {
    //             taken: true,
    //             score: quizDoc.data().score || 0,
    //             status: quizDoc.data().score >= 15 ? "Pass" : "Fail",
    //             attempts: quizDoc.data().attempts || 1,
    //           }
    //         : {
    //             taken: false,
    //             score: null,
    //             status: "Not Attempted",
    //             attempts: 0,
    //           };

    //       feedbackData[training.id] = !!feedbackDoc;
    //     });

    //     setQuizStatus(statusData);
    //     setFeedbackStatus(feedbackData);

    //     console.log(trainingsData)

    //   } catch (error) {
    //     toast.error("Error fetching trainings: " + error.message);
    //   } finally {
    //     setLoading(false);
    //   }
    // };


    const fetchTrainings = async () => {
      if (!currentUser) {
        toast.error("You must be logged in to view trainings.");
        navigate("/login");
        return;
      }
    
      try {
        const querySnapshot = await getDocs(collection(db, "trainings"));
        const trainingsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
    
        const sortedTrainings = trainingsData.sort((a, b) => a.name.localeCompare(b.name));
        setTrainings(sortedTrainings);
    
        const quizCollection = collection(db, "users", currentUser.uid, "quizzes");
        const feedbackCollection = collection(db, "users", currentUser.uid, "feedback");
    
        const [quizDocs, feedbackDocs] = await Promise.all([
          getDocs(quizCollection),
          getDocs(feedbackCollection),
        ]);
    
        const statusData = {};
        const feedbackData = {};
        const retakesData = {};
    
        await Promise.all(
          sortedTrainings.map(async (training) => {
            const quizDoc = quizDocs.docs.find((doc) => doc.id === training.id);
            const feedbackDoc = feedbackDocs.docs.find((doc) => doc.id === training.id);
    
            // Fetch all retakes for this training
            const allRetakes = await fetchAllRetakes(currentUser.uid, training.id);
    
            // Extract highest score from retakes
            const highestRetakeScore = allRetakes.length > 0
              ? Math.max(...allRetakes.map(retake => retake.score || 0))
              : null;
    
            // Store retake details
            retakesData[training.id] = allRetakes;
    
            statusData[training.id] = quizDoc
              ? {
                  taken: true,
                  score: quizDoc.data().score || 0,
                  highestRetakeScore: highestRetakeScore,
                  retakes: allRetakes, // Store all retakes
                  status: highestRetakeScore !== null 
                    ? highestRetakeScore >= 15 ? "Pass" : "Fail" 
                    : quizDoc.data().score >= 15 ? "Pass" : "Fail",
                  attempts: quizDoc.data().attempts || 1,
                }
              : {
                  taken: false,
                  score: null,
                  highestRetakeScore: null,
                  retakes: [],
                  status: "Not Attempted",
                  attempts: 0,
                };
    
            feedbackData[training.id] = !!feedbackDoc;
          })
        );
    
        setQuizStatus(statusData);
        setFeedbackStatus(feedbackData);
        setRetake(retakesData);
    
        // console.log("Retakes Data:", retakesData);
        
      } catch (error) {
        toast.error("Error fetching trainings: " + error.message);
      } finally {
        setLoading(false);
      }
    };
    


    const fetchAllRetakes = async (userId, trainingId) => {
      try {
        const retakeCollectionRef = collection(db, "users", userId, "quizzes", trainingId, "retakes");
        const retakeDocs = await getDocs(retakeCollectionRef);
    
        // Convert documents to an array of retake objects
        const retakes = retakeDocs.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(), // Spread all fields from Firestore
        }));
    
        return retakes;
      } catch (error) {
        console.error(`Error fetching retakes for ${trainingId}:`, error);
        return [];
      }
    };

    

    


    fetchTrainings();
  }, [currentUser, navigate]);

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleSearchChange = useCallback(
    debounce((value) => setSearchQuery(value), 300),
    []
  );

  const filteredTrainings = useMemo(
    () =>
      trainings.filter((training) =>
        training.name.toLowerCase().includes(searchQuery.toLowerCase())
      ),
    [trainings, searchQuery]
  );

  const questionPaperTrainings = filteredTrainings.filter(
    (training) => training.type === "mcq" || training.type === "true_false"
  );
  const declarationTrainings = filteredTrainings.filter(
    (training) => training.type === "declaration"
  );

  const formatType = (type) =>
    type ? type.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "N/A";

  const handleStartOrViewQuiz = (trainingId) => {
    navigate(`/view-training-questions/${trainingId}`);
  };

  const handleRetakeQuiz = (trainingId) => {
    navigate(`/retake-training-questions/${trainingId}`);
  };

  const handleFeedback = (trainingId) => {
    navigate(`/feedback/${trainingId}`);
  };

  if (loading) {
    return <div><div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
    <Spinner animation="border" variant="primary" />
  </div></div>;
  }

  return (
    <div className="container mt-3">
      <h2>All Trainings</h2>

      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search Trainings"
          onChange={(e) => handleSearchChange(e.target.value)}
          aria-label="Search Trainings"
        />
      </div>


      



      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : filteredTrainings.length === 0 ? (
        <p>No trainings found matching your search criteria.</p>
      ) : (
        <>
          {questionPaperTrainings.length > 0 && (
            <div>
              <h3>Question Paper Trainings</h3>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Training Name</th>
                    {/* <th>Type</th> */}
                    <th>Score</th>
                    <th>Status</th>
                    <th>Attempts</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {questionPaperTrainings.map((training) => (
                    <tr key={training.id}>
                      <td>{training.name}</td>
                      {/* <td>{formatType(training.type)}</td> */}
                      <td>
                        {quizStatus[training.id]?.taken
                          ? `${quizStatus[training.id].score} / 20`
                          : "Not Taken"}
                      </td>
                      <td className={quizStatus[training.id]?.status === "Pass" ? "text-success" : "text-danger"}>
                        {quizStatus[training.id]?.status} 
                      </td>
                      <td>{quizStatus[training.id]?.attempts || 0}</td>
                      <td>
                        <button
                          onClick={() => handleStartOrViewQuiz(training.id)}
                          className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
                        >
                          {quizStatus[training.id]?.taken ? "View Result" : "Start Quiz"}
                        </button>

                        
                        {quizStatus[training.id]?.status === "Fail" && retakes[training.id].map((Rattempts) => ( Rattempts.attempts.length)) < 1 ? (
                          <button
                            className="btn btn-sm btn-danger mx-2"
                            onClick={() => handleRetakeQuiz(training.id)}
                          >
                            Retake Test 
                          </button> 
                          )
                          :(  retakes[training.id].map((Rattempts) => ( Rattempts.attempts.length)) >= 2 &&
                            
                            <button
                            className="btn btn-sm btn-danger mx-2"
                            // onClick={() => handleRetakeQuiz(training.id)}
                          >
                            Limit Exceeds
                          </button> 
                        )}



                        {/* {quizStatus[training.id]?.taken && (
                          <button
                            className="btn btn-sm btn-warning ml-2"
                            onClick={() => handleFeedback(training.id)}
                          >
                            {feedbackStatus[training.id] ? "Feedback Submitted" : "Give Feedback"}
                          </button>
                        )} */}
                      
                      
                      </td>



                      




                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {declarationTrainings.length > 0 && (
            <div>
              <h3>Declaration Trainings</h3>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Training Name</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {declarationTrainings.map((training) => (
                    <tr key={training.id}>
                      <td>{training.name}</td>
                      <td>{formatType(training.type)}</td>
                      <td className={quizStatus[training.id]?.taken ? "text-success" : "text-danger"}>
                        {quizStatus[training.id]?.taken ? "Signed" : "Not Signed"}
                      </td>
                      <td>
                        <button
                          onClick={() => handleStartOrViewQuiz(training.id)}
                          className={`btn btn-sm ${quizStatus[training.id]?.taken ? "btn-success" : "btn-primary"}`}
                        >
                          {quizStatus[training.id]?.taken ? "View Declaration" : "Sign Declaration"}
                        </button>
                        {/* {quizStatus[training.id]?.taken && (
                          <button
                            className="btn btn-sm btn-warning ml-2"
                            onClick={() => handleFeedback(training.id)}
                          >
                            {feedbackStatus[training.id] ? "Feedback Submitted" : "Give Feedback"}
                          </button>
                        )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </div>
  );
};

export default ViewTrainings;
